// extracted by mini-css-extract-plugin
export default {"wrapper":"UserForm_wrapper__kYa6F"};